import React from "react";
import { MINUTOS_POR_UNIDAD } from "./intervaloLecturaUtils";

export default function IntervaloLectura({ cantidad, unidad, onCantidadChange, onUnidadChange, disabled = false }) {
  return <div>
    <p className="block mb-1">Tiempo de lectura</p>
    <div className="flex gap-2">
      <input type="number" min="1" step="1" max={Math.floor(2147483647 / MINUTOS_POR_UNIDAD[unidad])}
        aria-label="Cantidad del tiempo de lectura" value={cantidad} disabled={disabled}
        onChange={e => onCantidadChange(e.target.value)} placeholder="Ej. 1"
        className="min-w-0 flex-1 w-full p-2 rounded bg-neutral-700 text-white" />
      <select aria-label="Unidad del tiempo de lectura" value={unidad} disabled={disabled}
        onChange={e => onUnidadChange(e.target.value)} className="p-2 rounded bg-neutral-700 text-white">
        <option value="minutos">Minutos</option><option value="horas">Horas</option><option value="dias">Días</option>
      </select>
    </div>
    <p className="text-xs text-neutral-400 mt-1">1 hora = 60 minutos. 1 día = 24 horas.</p>
  </div>;
}
